import apis from "../api"

export const auth = {
  namespaced: true,
  state: {
    user: null,
    auth_token: '',
  },

  mutations: {
    LOGIN(state, info) {
      state.user = info.user
      state.auth_token = info.access_token 
    },

    LOGOUT(state) {
      state.user = null,
      state.auth_token = ''
    }
  },

  actions: {
    login({state, commit, dispatch}, user_creds) {
      return new Promise((resolve,reject) => {
        apis.user.login(user_creds)
          .then(response => {
            commit("LOGIN", response);
            apis.update_jwt(state.auth_token);
            resolve(response)
          }, error => {
            dispatch('feedback/show',{message: error, color: 'error'}, {root:true}) 
            reject(error)
          })
      })
    }
  },

  getters: {
    is_logged_in(state) {
      return state.user ? true : false
    },

    is_admin(state) {
        return (state.user) && (state.user.role == 'admin')
    },

    auth_token(state, getters) {
      if (getters.is_logged_in) {
        return state.auth_token
      }
      else {
        return null
      }
    }
  }
}